import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraMedicationManagementSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.528876 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M39.9867 49.509H23.5531C22.4287 49.509 21.5169 48.5972 21.5169 47.4728L20.7441 21.1315L43.1371 22.4822L42.0216 47.5158C41.9976 48.6225 41.0933 49.5078 39.9867 49.5078V49.509Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M27.6873 39.3397C26.5475 38.3901 24.8537 38.5442 23.9041 39.684C22.9544 40.8238 23.1086 42.5176 24.2484 43.4673L28.4537 46.971C29.5935 47.9207 31.2873 47.7665 32.237 46.6267C33.1866 45.4869 33.0325 43.7931 31.8927 42.8434L27.6873 39.3397Z'
        fill='#ABCEFE'
      />
      <Path
        d='M32.2368 46.6256C31.287 47.7651 29.5936 47.9194 28.4528 46.9696L26.4482 45.3128L29.887 41.1848L31.8916 42.8416C33.0311 43.7914 33.1853 45.4848 32.2356 46.6256H32.2368Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M35.3009 38.8613L34.0352 44.1866C33.6922 45.63 34.5841 47.0782 36.0275 47.4212C37.4709 47.7643 38.919 46.8723 39.2621 45.4289L40.5278 40.1036C40.8709 38.6603 39.9789 37.2121 38.5355 36.869C37.0922 36.526 35.644 37.4179 35.3009 38.8613Z'
        fill='#ABCEFE'
      />
      <Path
        d='M38.5379 36.8718C39.981 37.2145 40.8739 38.6639 40.5299 40.1069L39.938 42.6389L34.7109 41.3957L35.3028 38.8637C35.6456 37.4207 37.0949 36.5278 38.5379 36.8718Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M43.4331 19.1622L20.5697 19.013C20.1978 19.0104 19.8892 19.2975 19.8639 19.6681L19.6363 23.0853C19.6097 23.49 19.931 23.834 20.337 23.834H43.5633C43.963 23.834 44.2817 23.5014 44.2653 23.103L44.1299 19.835C44.1148 19.4607 43.8074 19.1647 43.4331 19.1622Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M41.837 16.5266L22.5021 15.8297C21.8951 15.8082 21.3626 16.1927 21.2551 16.7327L20.3711 21.1681H43.5102L42.9967 17.4865C42.9221 16.954 42.4314 16.5481 41.837 16.5266Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
